
  export default function generateUnique(min, max) {
    let _random = ""
    for(let i = 0; i < 8; i++){
      min = Math.ceil(min);
      max = Math.floor(max);
      _random = _random + (Math.floor(Math.random() * (max - min + 1)) + min).toString()
    }

    return _random.slice(0, 4) + "-"+ _random.slice(4, 8);
  }
